import { useCableRankerStore } from "@/stores/CableRankerStore";
import { useErrorStore } from "@/stores/ErrorStore";

export const CableRankerStores = [useCableRankerStore, useErrorStore];

export const CableRankerChannel = {
  received(payload) {
    if (payload.id === this.cableRankerStore.quartersTaskId) {
      this.cableRankerStore.loadingQuarters = false;
      if (payload.status === "error" || payload.data?.status === "error") {
        this.errorStore.showError(payload.message);
      } else {
        this.cableRankerStore.quarters = payload.data.quarters;
      }
    }
    if (payload.id === this.cableRankerStore.rankingsTaskId) {
      if (payload.status === "error" || payload.data.status === "error") {
        this.errorStore.showError(payload.message);
        this.cableRankerStore.loading = false;
      } else {
        this.cableRankerStore.setRatingsData(payload.data.ratings);
      }
    }
  },
};
